import React, { useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/partner-quota-action";
import * as uiHelpers from "../PartnerQuotaUIHelpers";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { usePartnerQuotaUIContext } from "../PartnerQuotaUIContext";
import { RoleChecker } from "../../../../RoleChecker";

const PartnerQuotaTable = (props) => {
  // PartnerQuota UI Context
  const partnerQuotaUIContext = usePartnerQuotaUIContext();
  const partnerQuotaUIProps = useMemo(() => {
    return {
      queryParams: partnerQuotaUIContext.queryParams,
      setQueryParams: partnerQuotaUIContext.setQueryParams,
      openEditPartnerQuotaPage: partnerQuotaUIContext.openEditPartnerQuotaPage,
    };
  }, [partnerQuotaUIContext]);

  // Getting curret state of partnerQuota list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.partnerQuota }),
    shallowEqual
  );

  const { totalCount, groupEntities, listLoading } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    dispatch(actions.fetchPartnerQuotaGroups(partnerQuotaUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerQuotaUIProps.queryParams, dispatch]);
  
  useEffect(() => {
    return () => {
      dispatch(actions.resetInitialFormValue())
    }
  }, []);
  
  const allowHistory = RoleChecker("Read", "partner-quota");

  // Table columns
  const columns = [
    {
      dataField: "partner_name",
      text: "Mitra",
      sort: true,
    },
    {
      dataField: "livestock_name",
      text: "Hewan",
      sort: true,
    },
    {
      dataField: "area_name",
      text: "Wilayah",
      sort: true,
    },
    {
      dataField: "quota",
      text: "Kuota",
      sort: true,
    },
    {
      dataField: "distributed",
      text: "Terdistribusi",
      sort: true,
    },
    {
      dataField: "remaining",
      text: "Sisa",
      sort: true,
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditPartnerQuotaPage: partnerQuotaUIProps.openEditPartnerQuotaPage,
        allowHistory,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: partnerQuotaUIProps.queryParams.pageSize,
    page: partnerQuotaUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={groupEntities === null ? [] : groupEntities}
                columns={columns}
                onTableChange={getHandlerTableChange(
                  partnerQuotaUIProps.setQueryParams
                )}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={groupEntities} />
                <NoRecordsFoundMessage entities={groupEntities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default PartnerQuotaTable;
